<template>
  <div class="coursemanagement">
    <div class="header">
      <el-input v-model="param.RealName" :placeholder="$t('Education.languages03')" clearable style="width: 200px;margin-right: 30px"></el-input>
      <el-button type="primary" @click="handleinitialization(1)">{{ $t('Education.languages01')}}</el-button>
      <el-button type="primary" @click="addfun()">新增</el-button>
    </div>

    <div class="content">
      <el-table v-loading="courseload" :data="CourseData" :cell-style="{'text-align':'center'}" :header-cell-style="{'text-align':'center'}" style="width: 100%">
        <el-table-column prop="RealName" label="姓名"></el-table-column>
        <el-table-column prop="IndividualResume" label="介绍"></el-table-column>
        
        <el-table-column label="操作">
     

          <template v-slot="scope">
            <el-popconfirm  @confirm="ClickDelete(scope.row)" title="是否确定删除？">
              <span class="operateitem" slot="reference">{{ $t('Education.languages07')}}</span>
            </el-popconfirm>


            <span style="margin-left:10px" class="operateitem" @click="xgfun(scope.row)">修改</span>
          </template>

         


        </el-table-column>
      </el-table>

      <el-pagination class="pagination"  @current-change="handleinitialization" :current-page.sync="param.pageIndex" :page-size="param.pageSize" layout="total, prev, pager, next" :total="param.PageTotal">
      </el-pagination>
    </div>

    <el-drawer :visible.sync="drawer" :with-header="false" size="50%">
        <h2 style="padding:15px">专家管理</h2>

        <el-form ref="form" :model="form">
          <el-form-item label="姓名" label-width="80px">
            <el-input v-model="form.RealName" placeholder="请输入内容"></el-input>
          </el-form-item>

          <el-form-item label="介绍" label-width="80px">
            <el-input  type="textarea" v-model="form.IndividualResume" placeholder="请输入内容"></el-input>
          </el-form-item>

          <el-form-item label="头像" label-width="80px" v-loading="teacherload">
            <el-upload
              class="upload-demo"
                :action="actionUrl"
                :headers="{Authorization:Authorization}"
                name="images"
                :show-file-list="false"
                accept="image/jpeg,image/png,image/jpg"
                :before-upload="beforeuploadphoto"
                :on-success="(value)=> handsuccess(value)"
            >
              <img v-show="form.ZHeadPhotoURL" :src="form.ZHeadPhotoURL" style="width: 160px;height: 160px;">
              <span class="el-icon-plus uploadicon" v-if="!form.ZHeadPhotoURL"></span>
            </el-upload>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit" style="margin-left:100px">确定</el-button>
          </el-form-item>

        </el-form>
      </el-drawer>

  </div>
</template>

<script>
export default ({

  data(){
    return{
      form:{
        RealName:'',
        IndividualResume:'',
        ZHeadPhotoURL:'',
      },
      teacherload:false,
      UserID:'',
      type:1,
      drawer:false,
      rules:{
        RealName:[
          {required: true, message:"请输入课程名", trigger: 'blur'}
        ],
        courseDescription:[
          {required: true, message:"请输入课程说明", trigger: 'blur'}
        ],
        courseCover:[{required: true, message:"请上传封面图", trigger: 'change'}]
      },
      actionUrl:process.env.VUE_APP_URL+'AppUser/UpdatePortraitAndCertificate',
      Authorization:sessionStorage.getItem('Authorization'),
      CourseData:[],
      courseload:false,
      param:{
        RealName:'',
        pageIndex:1,
        pageSize:10,
        PageTotal:1,
      },
    }
  },
  created() {
    this.CourseList();
  },
  mounted() {

  },
  methods:{
    addfun(){
      this.type = 1
      this.drawer = true
      this.form={
        RealName:'',
        IndividualResume:'',
        ZHeadPhotoURL:''
      }
    },
    xgfun(row){
      this.type = 2
      this.drawer = true
      this.form={
        RealName:row.RealName,
        IndividualResume:row.IndividualResume,
        ZHeadPhotoURL:row.ZHeadPhotoURL
      }
      this.UserID = row.UserID
    },
    beforeuploadphoto(file){
      if(file.type == 'image/jpg' || file.type == 'image/jpeg' || file.type == 'image/png') {
        this.teacherload=true;
      }else{
        this.$message({type: 'error', message:"请上传正确的图片格式"});
      }
    },
    handsuccess(value){
      this.teacherload=false;
      if(value.Code == 200 || value.Code == 0){
        this.form.ZHeadPhotoURL = value.Data;
      }else{
        this.$message({type: 'error', message: value.Message});
      }
    },
    onSubmit(){
      if(this.type == 1){
        this.$Http_Post("/User/addExpertUser",{RealName: this.form.RealName,ZHeadPhotoURL: this.form.ZHeadPhotoURL,IndividualResume:this.form.IndividualResume}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.Global.request_successful(res.Message);
            this.CourseList();
            this.form={
              RealName:'',
              IndividualResume:'',
            }
            this.drawer = false;
          } else {
            this.Global.request_failure(res.Message);
          }
        })
      }else if(this.type == 2){

        this.$Http_Post("/User/updateExpertUser",{RealName: this.form.RealName,ZHeadPhotoURL: this.form.ZHeadPhotoURL,IndividualResume:this.form.IndividualResume,UserID:this.UserID}).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.Global.request_successful(res.Message);
            this.CourseList()
            this.form={
              RealName:'',
              IndividualResume:'',
            }
            this.drawer = false;
          } else {
            this.Global.request_failure(res.Message);
          }
        })

      }
      
    },
    // 课程列表
    CourseList(){
      this.$Http_Post('/User/getExpertUser',this.param).then(res=>{
        if(res.Code == 200){
          this.CourseData = res.Data;
          this.param.PageTotal = res.Counts;
          this.courseload = false;
        }
      })
    },
    handleinitialization(val){
      this.courseload = true;
      this.param.pageIndex = val;
      this.CourseList();
    },
    // 删除
    ClickDelete(e){
      //UserID
      this.$Http_Post('/User/DeleteUser',{UserID:e.UserID}).then(res=>{
        if(res.Code == 200){
          this.CourseList();
          this.$message({
            type: 'success',
            message: res.Message,
          })
        }else{
          this.$message({type: 'error', message: res.Message})
        }
      })

    },
    CreatexamChapterName(row){
      return row.recentLiveTime?row.recentLiveTime:'暂无直播'
    }
  },
})
</script>
<style>
.coursemanagement .header{display: flex;align-items:center;background: #fff;padding:20px 30px;}
.coursemanagement .content{background:#fff;padding:30px;margin-top:20px;}
.operateitem{padding: 0 5px 0 0;color:#0088ff;cursor: pointer}
.coursemanagement .el-color-picker__icon, .el-input, .el-textarea{width: 74%;}
.coursemanagement .upload-demo{width:160px;height: 160px;background: #f5f7fa;}
.coursemanagement .upload-demo .el-upload{width:160px;height: 160px;}
.coursemanagement .el-form{margin-left: 15px;}
.coursemanagement .el-avatar>img{width: 100%;}
.coursemanagement .upload-demo .uploadicon{font-size: 30px;line-height: 160px;color: #d4d4d4;}
</style>